import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { useEffect, useState } from 'react'
import { apiService } from '../../api/axiosClient'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import SectionAccount from '../../views/mall/mallaccount'
import SectionDelivery from '../../views/mall/malldelivery'
import SectionInfo from '../../views/mall/mallinfo'
import PointConfigureTable from '../../views/mall/mallpoint'

const Mall = () => {
  const [mall, setMall] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiService.get('/malls');
        const payload = response.data;
        setMall(payload.data);
      } catch (error) {
        console.error('Error fetching mall data:', error);
      }
    }

    fetchData();
  }, [])

  return (
    <Page title="Mall">
      <Box>
        <PageHeader
          title={
            <Typography variant='h5' color='#666CFF'>
              쇼핑몰관리
            </Typography>
          }
        />

        <Grid container spacing={6} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <SectionInfo mall={mall} />
          </Grid>
          <Grid item xs={12} md={6}>
            <SectionAccount mall={mall} />
          </Grid>
          <Grid item xs={12} md={6}>
            <SectionDelivery mall={mall} />
          </Grid>
          <Grid item xs={12} md={6}>
            <PointConfigureTable />
          </Grid>
        </Grid>
      </Box>
    </Page>
  )
}

export default Mall
